import React, { useContext, useState } from "react";

type BenliebAppState = ReturnType<typeof useInitAppContextState>

export const BenliebAppContext = React.createContext<BenliebAppState>({} as BenliebAppState);
export const useBenliebAppContext = () => useContext(BenliebAppContext)

export const useInitAppContextState = () => {

  const return_val = {
    pageUsesSidebar: true,
  }

  return return_val;
};
